/* @flow */

import React from 'react';
import {connect} from 'react-redux';
import {dashedToCamelCase, showPrintAddress} from '../../../common/lib/util';

class PrintType extends React.Component {

  static propTypes = {
      msg: React.PropTypes.object,
    printLength: React.PropTypes.number,
    printAddress: React.PropTypes.string,
    printType: React.PropTypes.string,
    printTypeOptions: React.PropTypes.object,
    openPopup: React.PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.openPopup = this.openPopup.bind(this);
  }

  openPopup() {
    const {openPopup} = this.props;
    openPopup();
  }

  render() {
    const {printType, printTypeOptions, printAddress, printLength, msg} = this.props;

    return (
      <div className="table-row">
        <div className="table-cell" style={{width: '55.55%'}}>
          <div className="boxBtn text-left text-black">
            <div className="boxBtn-inner">
              <div className="settings-name">
                <span>{msg.settings.printType.title}</span>
                  <span className="settings-name-info">{msg.settings.printType.subtitle}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="table-cell" style={{width: '22.22%'}}>
          <div className="boxBtn text-black text-l">
            <div className="boxBtn-inner">
              <span>
                {msg.settings.printType[dashedToCamelCase(printType)]} {!!printType && !!printAddress && showPrintAddress(printType) && `(${printAddress})`}
                {printType.indexOf('escpos') > -1 && <br/>}
                {printType.indexOf('escpos') > -1 && ` ${printLength} ${msg.settings.printType.charOnLine}`}
              </span>
            </div>
          </div>
        </div>
        <div className="table-cell" style={{width: '22.22%'}}>
          <div className="boxBtn color-green text-l">
            <div className="boxBtn-inner" onClick={this.openPopup}>
              <span>{msg.settings.printType.change}</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => ({
    msg: state.intl.trans[state.intl.currentLocale],
  printAddress: state.device.printAddress,
  printType: state.device.printType,
  printTypeOptions: state.device.printTypeOptions,
  printLength: state.device.get('printLength')
}), {})(PrintType);



// WEBPACK FOOTER //
// ./src/browser/menu/settings/PrintType.js